export function getTotalMatches (player) {
  return player.wins + player.losses + player.numMissedMatches;
}

export function computeNumMissedMatches (players) {
  const presentPlayers = players.filter(p => p.present);
  if (presentPlayers.length === 0) return 0;
  const sum = presentPlayers.reduce((acc, p) => acc + getTotalMatches(p) + (p.active ? 1 : 0), 0);
  return Math.round(sum / presentPlayers.length);
}

export function applyLateArrivalGrace (count) {
  return Math.max(0, count - 2);
}
